const mediaQuery = window.matchMedia('(max-width: 1000px)');
    function handleAccordionQuery(e) {
      if (e.matches) {
        document.querySelectorAll('.accordion.close_mobile').forEach(accordion => {
          accordion.open = false;
        });
      } else {
        document.querySelectorAll('.accordion.close_mobile').forEach(accordion => {
          accordion.open = true;
        });
      }

    }
handleAccordionQuery(mediaQuery);
mediaQuery.addEventListener('change', handleAccordionQuery);


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}